module.exports = __webpack_public_path__ + "img/UP380C&BT3.pic.11023d51.png";